import styles from "./index.module.scss";
import Table from "react-bootstrap/Table";
import { IHit } from "../../../../../../types";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import {
  addToCart,
  incrementBasketAmount,
} from "../../../../../../redux/reducers";
import { isInBusket } from "../../../../../../utils/functions/isInBasket";
import { getCartState } from "../../../../../../redux/selectors";
import { toast } from "react-toastify";
import { SplitToLines } from "../../../../../../utils/functions/nextLineString";
const Layout = ({ catalog, hitProductId, registeredTime }: IHit) => {
  const dispatch = useAppDispatch();
  const cart = useAppSelector((state) => getCartState(state));
  const addToCartHandler = () => {
    let inCart = isInBusket(cart, catalog.catalogName, hitProductId);

    if (inCart) {
      dispatch(incrementBasketAmount(hitProductId));
      toast("Увеличено в Корзине ", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        pauseOnHover: true,
        theme: "light",
        type: "success",
      });
    } else {
      toast("Добавленно в корзину", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        pauseOnHover: true,
        theme: "light",
        type: "success",
      });
      dispatch(
        addToCart({
          amount: 1,
          catalogType: catalog.catalogType,
          detailName: catalog.catalogName,
          price: catalog.price,
          id: hitProductId,
          vinNumber: "",
        })
      );
    }
  };

  return (
    <div className={styles.container}>
      <h1 className="title"> {catalog.catalogName} </h1>
      <Table className={styles.table}>
        <thead>
          <tr>
            <th>В Наличии</th>
            <th>Описание</th>
            <th></th>
            <th></th>
            <th> Цена за штуку</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{catalog.amount}</th>
            <th>{SplitToLines(catalog.description)}</th>
            <th></th>
            <th></th>
            <th> {catalog.price}&#8381;</th>
          </tr>
        </tbody>
      </Table>
      <div className={styles.footer_table}>
        <button onClick={addToCartHandler}>В корзину</button>
      </div>
    </div>
  );
};

export default Layout;
